"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { isTrustPulseHidden } from "@/helpers/isTrustPulseHidden";

/**
 * Hides the TrustPulse pop-up on the pages listed in `config/trustPulse.ts`.
 *
 * TrustPulse cannot be told to close its pop-up, and it only checks its own
 * page rules on a full page load, so this marks the page instead and a global
 * style (`tools/sass/global/_trustpulse.scss`) hides the pop-up while the mark
 * is there. Leaving the page removes the mark, and the pop-up shows again
 * unless it has been closed.
 */
const TrustPulseVisibility = () => {
  const hidden = isTrustPulseHidden(usePathname());

  useEffect(() => {
    document.documentElement.toggleAttribute("data-trustpulse-hidden", hidden);
  }, [hidden]);

  return null;
};

export default TrustPulseVisibility;
